'use strict';

// Init the application configuration module for AngularJS application
var ApplicationConfiguration = (function () {
  // Init module configuration options
  var applicationModuleName = 'applanga';
  var applicationModuleVendorDependencies = [
    'ngResource',
    'ngCookies',
    'ngAnimate',
    'ngTouch',
    'ngSanitize',
    'ngRaven',
    'ui.router',
    'ui.bootstrap',
    'ui.scroll',
    'ui.scrollpoint',
    'ui.event',
    'ui.mask',
    'ui.validate',
    'ui.indeterminate',
    'ui.uploader',
    'ui.mention',
    'angular-bind-html-compile',
    'oitozero.ngSweetAlert',
    'monospaced.elastic',
    'ngClipboard',
    'angularFileUpload',
    'wu.masonry',
    'ngIntercom',
    'ngFileUpload',
    'ui.indeterminate',
    'ui.scroll',
    'angulartics',
    'angulartics.mixpanel',
    'ngAside',
    'ngTagsInput'
  ];

  // Add a new vertical module
  var registerModule = function (moduleName, dependencies) {
    // Create angular module
    angular.module(moduleName, dependencies || []);

    // Add the module to the AngularJS configuration file
    angular.module(applicationModuleName).requires.push(moduleName);
  };

  return {
    applicationModuleName: applicationModuleName,
    applicationModuleVendorDependencies: applicationModuleVendorDependencies,
    registerModule: registerModule
  };

})();
